'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IS_SCROLLING_TIMEOUT = exports.WindowScroller = undefined;

var _WindowScroller = require('./WindowScroller');

var _WindowScroller2 = _interopRequireDefault(_WindowScroller);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _WindowScroller2.default;
exports.WindowScroller = _WindowScroller2.default;
exports.IS_SCROLLING_TIMEOUT = _WindowScroller.IS_SCROLLING_TIMEOUT;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-virtualized/dist/commonjs/WindowScroller/index.js
 ** module id = 1333
 ** module chunks = 0
 **/